var map = {
	"./avatar_real_1.jpg": "3fd3",
	"./avatar_real_2.jpg": "36e4",
	"./avatar_real_3.jpg": "118c",
	"./avatar_real_4.jpg": "8803",
	"./avatar_real_5.jpg": "7450",
	"./avatar_real_6.jpg": "ee6c",
	"./avatar_real_7.jpg": "bebb",
	"./avatar_real_8.jpg": "55ca",
	"./avatar_real_9.jpg": "1013"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aeb0";